<template>
    <div>
        <div class="container-fluid mt-2 mb-5">
            <div class="row">
                <!-- Added patient details section -->
                <div class="col-md-12 mt-2">
                    <div class="row">
                        <div class="col-md-8">
                            <p>
                                <strong class="fw-bold">Nombre:</strong> {{ paciente?.nombre || 'No aplica' }} |
                                <strong class="fw-bold">Fecha de Nacimiento:</strong> {{ paciente?.fecha_nacimiento ?
                                formatDate(paciente.fecha_nacimiento) : 'No aplica' }} |
                                <strong class="fw-bold">Edad:</strong> {{ paciente?.fecha_nacimiento ?
                                calculateAge(paciente.fecha_nacimiento) : 'No calculada' }} <br>
                                <strong class="fw-bold">Género:</strong> {{ paciente?.genero || 'No aplica' }}
                                <strong class="fw-bold">Teléfono:</strong> {{ paciente?.telefono || 'No aplica' }} |
                                <strong class="fw-bold">Email:</strong> {{ paciente?.email || 'No aplica' }} |
                                <strong class="fw-bold">Dirección:</strong> {{ paciente?.direccion || 'No aplica' }} <br>
                                <strong class="fw-bold">Tiene Seguridad Social:</strong> {{ paciente?.tiene_seguridad_social ? 'Sí' : 'No' }} |
                                <strong class="fw-bold">Institución de Salud:</strong> {{ paciente?.institucion_salud || 'No aplica' }}
                            </p>
                        </div>
                        <div class="col-md-4 text-end">
                            <p>
                                <strong class="fw-bold">Motivo de consulta:</strong> {{ notaMedicaConsultas?.motivo || 'No aplica' }} <br>
                                <strong class="fw-bold">Origen:</strong> {{ notaMedicaConsultas?.origen || 'No aplica' }} <br>
                                <strong class="fw-bold">Estatus de cita:</strong> {{ notaMedicaConsultas?.estatus_cita || 'No aplica' }} <br>
                                <strong class="fw-bold">Estatus de nota:</strong> {{ notaMedicaConsultas?.estatus_nota || 'No aplica' }} <br>
                                <strong class="fw-bold">Tipo de consulta:</strong> {{ notaMedicaConsultas?.tipo_consulta || 'No aplica' }} <br>
                                <strong class="fw-bold">Fecha de atención:</strong> {{ notaMedicaConsultas?.inicio_cita ? 
                                new Date(notaMedicaConsultas.inicio_cita).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : 'No aplica' }}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- Existing form section -->
                <div class="col-md-12  mb-3">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <p class="text-muted mt-2">Los campos marcados con <span class="text-danger">*</span> son
                                    obligatorios.</p>
                                    <div  class="row">
                                        <div class="col-md-12 mb-3">
                                            <label class="form-label">Recomendaciones generales sobre el tratamiento, aqui puedes solicitar estudios a laboratorios para el paciente. <span class="text-danger">*</span></label>
                                            <textarea class="form-control" rows="5" maxlength="1000"
                                            v-model.trim="observaciones"></textarea>
                                            <small class="text-muted">Si tu paciente no requiere estudios, deja el campo en blanco.</small>
                                        </div>
                                        <div class="col-md-8">
                                            <search-medicamentos :main-id="currentUser?.mainId" @notify="notify" @select="handleMedicamentoSelected" />
                                            <small class="text-muted">Si tu paciente no requiere medicamentos, deja los campos en blanco.</small>
                                        </div>
                                        <div class="col-md-4 d-flex align-items-center justify-content-end">
                                            <a class="smallText text-center" @click="agregarMedicamentoManual"
                                            href="#">➕ Agregar medicamento manualmente</a>
                                        </div>
                                    </div>
                                    <div  v-for="(medicamento, index) in medicamentosRecetados" :key="index" class="mt-3">
                                        <div class="row">
                                            <div class="col-md-4 mb-3">
                                                <label class="form-label">Medicamento</label>
                                                <input type="text" class="form-control" v-model="medicamento.medicamento" />
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label class="form-label">Dosis</label>
                                                <input type="text" class="form-control" v-model="medicamento.dosis" />
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label class="form-label">Frecuencia</label>
                                                <input type="text" class="form-control" v-model="medicamento.frecuencia" />
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label class="form-label">Duración</label>
                                                <input type="text" class="form-control" v-model="medicamento.duracion" />
                                            </div>
                                            <div class="col-md-4 mb-3">
                                                <label class="form-label">Observaciones</label>
                                                <input type="text" class="form-control" v-model="medicamento.observaciones" />
                                            </div>
                                            <div class="col-md-4 mb-3 text-end">
                                               <a class="smallText text-center" @click="eliminarMedicamento(index)"
                                            href="#">❌ Eliminar</a>
                                            </div>
                                        </div>
                                    </div>

                                
                                    <div class="col-md-12 mt-3 text-center" v-if="userStats !== 1">
                                        <p>
                                            Guarda los cambios cuando hayas terminado de agregar medicamentos.
                                        </p>
                                        <vs-button type="submit" color="rgb(59,222,200)" gradient block @click="agregarMedicamentos">
                                           💾 Guardar datos
                                        </vs-button>
                                    </div>
                                       <div class="col-md-12" v-else>
                                            <div class="alert alert-warning text-center">
                                                ⚠️ Tu paquete de Medicynia se encuentra expirado. Para continuar utilizando esta funcionalidad, por favor renueva tu suscripción. <br>
                                                <router-link to="/paquetes">Renovar aquí</router-link>
                                            </div>
                                        </div>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 mt-3 mb-3">
                    
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <div style="border: 1px solid #ccc; padding: 16px; border-radius: 8px; background-color: #f9f9f9;">
                                <h3>📌 Información importante sobre el envío de documentos médicos digitales</h3>
                                <p>
                                    De acuerdo con la <strong>NOM-004-SSA3-2012</strong> y otras disposiciones legales aplicables en México, cualquier documento médico emitido por el profesional de la salud —incluyendo <strong>recetas médicas, órdenes o solicitudes de estudios de laboratorio, interconsultas y referencias</strong>— debe cumplir con criterios de <strong>confidencialidad, autenticidad e integridad</strong> para ser considerado válido y seguro.
                                </p>
                                <ul>
                                    <li>Estos documentos contienen <strong>datos personales sensibles</strong> del paciente.</li>
                                    <li>El envío por medios como WhatsApp, correo electrónico u otras plataformas de mensajería <strong>no garantiza la protección adecuada ni el control del acceso a la información</strong>.</li>
                                    <li><strong>La responsabilidad del resguardo y envío</strong> de estos documentos recae en el médico que los emite.</li>
                                </ul>
                                <p>
                                    <strong>Recomendación:</strong> Si decide compartir estos documentos por medios digitales, asegúrese de que:
                                    <ul>
                                    <li>El canal sea confiable y seguro.</li>
                                    <li>El destinatario sea efectivamente el paciente o un tercero autorizado.</li>
                                    <li>El documento no sea alterado ni compartido sin consentimiento.</li>
                                    </ul>
                                </p>
                                </div>

                        </div>
                        <div class="col-md-12 mt-3">
                            <h3 class="card-title">💊 Recetas</h3>
                            <p>Al generar un link de la receta, el paciente tendrá solamente 72 horas para descargarla.</p>
                        </div>
                        <div class="col-md-4 mt-3" v-for="(receta, recetaId) in groupedRecetas" :key="recetaId" >
                            <div class="card h-100">
                                <div class="card-header">
                                    <small class="text-muted">📅 Fecha de creación: {{ receta[0]?.receta_creado_en ? 
                                    new Date(receta[0].receta_creado_en).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : 'No aplica' }}</small>
                                </div>
                                <div class="card-body">
                                    <div v-for="(medicamento, index) in receta" :key="medicamento.id" class="mb-3">
                                        <p class="smallText text-start">
                                            <strong>Medicamento:</strong> {{ medicamento.medicamento }} <br>
                                            <strong>Dosis:</strong> {{ medicamento.dosis }} <br>
                                            <strong>Frecuencia:</strong> {{ medicamento.frecuencia }} <br>
                                            <strong>Duración:</strong> {{ medicamento.duracion }} <br>
                                            <strong>Observaciones:</strong> {{ medicamento.observaciones }} <br>
                                        </p>
                                        <hr v-if="index < receta.length - 1" />
                                    </div>
                                </div>
                                <div class="card-footer">    
                                    <a class="smallText text-center" @click="imprimirReceta(receta,recetaId)" href="#">
                                        🖨️ Imprimir receta 
                                    </a>
                                    <a class="smallText text-center ms-3" @click="copiarLinkReceta(receta,recetaId)" href="#">
                                        📋 Copiar link de receta
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 mt-5">
                    <div class="row">
                        <div class="col-md-12">
                            <h3 class="card-title">🧪 Solicitudes de Estudios</h3>
                            <p>Al generar un link de la solicitud, el paciente tendrá solamente 72 horas para descargarla.</p>
                        </div>
                        <div class="col-md-4 mt-1" v-for="solicitud in solicitudesEstudios" :key="solicitud.id">
                            <div class="card h-100">
                                <div class="card-header">
                                    <small class="text-muted">📅 Fecha de creación: {{ solicitud.creado_en ? 
                                    new Date(solicitud.creado_en).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : 'No aplica' }}</small>
                                </div>
                                <div class="card-body">
                                    <p class="smallText text-start">
                                        <strong>Observaciones:</strong> {{ solicitud.observaciones || 'No aplica' }}
                                    </p>
                                </div>
                                <div class="card-footer">
                                    <a class="smallText text-center" @click="imprimirSolicitud(solicitud,solicitud.id )" href="#">
                                        🖨️ Imprimir solicitud 
                                    </a>
                                     <a class="smallText text-center ms-3" @click="copiarLinkSolicitud(solicitud,solicitud.id)" href="#">
                                        📋 Copiar link de solicitud
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import SearchMedicamentos from './SearchMedicamentos.vue';
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "Consulta",
        components: {
            SearchMedicamentos
        },
        props: {
            currentUser: {
                type: Object,
                required: true
            },
            paciente: {
                type: Object,
                required: true
            },
            notaMedicaConsultas: {
                type: [Array, Object], // Acepta tanto Array como Object
                required: true
            }
        },
        data() {
            return {
                userStats: null,
                medicamentosRecetados: [], // Array to store prescribed medications
                observaciones: '',
                recetas: [], // Array to store fetched recetas
                solicitudesEstudios: [] // Array to store fetched solicitudes de estudios
            };
        },
        computed: {
            groupedRecetas() {
                // Agrupa los medicamentos por receta_id
                return this.recetas.reduce((groups, medicamento) => {
                    const recetaId = medicamento.receta_id || 'Sin ID';
                    if (!groups[recetaId]) {
                        groups[recetaId] = [];
                    }
                    groups[recetaId].push(medicamento);
                    return groups;
                }, {});
            }
        },
        methods: {

            async imprimirSolicitud(consulta, recetaId) {
                console.log('Consulta:', consulta);
                var datosEnviar={};
                datosEnviar.displayName = this.currentUser?.displayName || 'No especificado';
                datosEnviar.personal_medico_id = this.currentUser?.mainId;
                datosEnviar.datosPaciente = this.paciente;
                datosEnviar.signos_vitales = this.notaMedicaConsultas.signos_vitales;
                datosEnviar.motivo = this.notaMedicaConsultas.motivo;
                datosEnviar.consulta_id = recetaId;
                datosEnviar.creado_en = consulta.creado_en
                datosEnviar.tratamientos = consulta;
                
                console.log('Medicamento seleccionado:', datosEnviar);
          
                try {
                    this.openLoading();
                    const response = await axios.post(`${API}/imprimir-solicitud`, datosEnviar);
                    if (response.data.status === 'success') {
                        this.closeLoading();
                        console.log('Receta médica generada:', response.data);

                        await this.callAudit(this.currentUser?.mainId,"IMPRESION","solicitudes_estudios",this.notaMedicaConsultas.id, `Impresión de solicitud de estudios`);

                        const pdfUrl = `${API}${response.data.pdfUrl}`;

                        // Verificar si es un dispositivo móvil
                        if (this.isMobileDevice()) {
                            // En móvil, abrir en una nueva pestaña
                            window.open(pdfUrl, '_blank');
                            this.notify('info', 'El PDF se abrirá en una nueva pestaña.');
                        } else {

                                const modal = document.createElement("div");
                                modal.style.position = "fixed";
                                modal.style.top = "0";
                                modal.style.left = "0";
                                modal.style.width = "100%";
                                modal.style.height = "100%";
                                modal.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
                                modal.style.display = "flex";
                                modal.style.justifyContent = "center";
                                modal.style.alignItems = "center";
                                modal.style.zIndex = "1051";

                                const iframe = document.createElement("iframe");
                                iframe.src = pdfUrl;
                                iframe.style.width = "80%";
                                iframe.style.height = "80%";
                                iframe.style.border = "2px solid white";
                                iframe.style.borderRadius = "10px";

                                const closeButton = document.createElement("span");
                                closeButton.textContent = "✖";
                                closeButton.style.position = "absolute";
                                closeButton.style.top = "20px";
                                closeButton.style.right = "20px";
                                closeButton.style.color = "white";
                                closeButton.style.fontSize = "24px";
                                closeButton.style.cursor = "pointer";
                                closeButton.addEventListener("click", () => {
                                    document.body.removeChild(modal);
                                });

                                modal.appendChild(iframe);
                                modal.appendChild(closeButton);
                                document.body.appendChild(modal);
                    }
                    } else {
                        this.closeLoading();
                        this.notify('error', 'Error al generar la receta médica.');
                    }
                } catch (error) {
                    this.closeLoading();
                    this.notify('error', `Error al generar la receta: ${error.response?.data?.message || error.message}`);
                }
            },
            async copiarLinkSolicitud(consulta, recetaId) {
                console.log('Consulta:', consulta);
                var datosEnviar={};
                datosEnviar.displayName = this.currentUser?.displayName || 'No especificado';
                datosEnviar.personal_medico_id = this.currentUser?.mainId;
                datosEnviar.datosPaciente = this.paciente;
                datosEnviar.signos_vitales = this.notaMedicaConsultas.signos_vitales;
                datosEnviar.motivo = this.notaMedicaConsultas.motivo;
                datosEnviar.consulta_id = recetaId;
                datosEnviar.creado_en = consulta.creado_en
                datosEnviar.tratamientos = consulta;
                
                console.log('Medicamento seleccionado:', datosEnviar);
          
                try {
                    this.openLoading();
                    const response = await axios.post(`${API}/imprimir-solicitud`, datosEnviar);
                    if (response.data.status === 'success') {
                        this.closeLoading();
                        console.log('Receta médica generada:', response.data);

                        await this.callAudit(this.currentUser?.mainId,"COPIAR ENLACE","solicitudes_estudios",this.notaMedicaConsultas.id, `Impresión de solicitud de estudios`);

                        const pdfUrl = `${response.data.qrData}`;
                        navigator.clipboard.writeText(pdfUrl).then(() => {
                            this.notify('success', 'El enlace de la receta se ha copiado al portapapeles.');
                        }).catch(err => {
                            this.notify('error', 'No se pudo copiar el enlace al portapapeles.');
                        });

                    } else {
                        this.closeLoading();
                        this.notify('error', 'Error al generar la receta médica.');
                    }
                } catch (error) {
                    this.closeLoading();
                    this.notify('error', `Error al generar la receta: ${error.response?.data?.message || error.message}`);
                }
            },

            async imprimirReceta(consulta, recetaId) {
                var datosEnviar={};
                datosEnviar.displayName = this.currentUser?.displayName || 'No especificado';
                datosEnviar.personal_medico_id = this.currentUser?.mainId;
                datosEnviar.datosPaciente = this.paciente;
                datosEnviar.signos_vitales = this.notaMedicaConsultas.signos_vitales;
                datosEnviar.motivo = this.notaMedicaConsultas.motivo;
                datosEnviar.consulta_id = recetaId;
                datosEnviar.creado_en = consulta[0].receta_creado_en
                datosEnviar.tratamientos = consulta;
                
                console.log('Medicamento seleccionado:', datosEnviar);
          
                try {
                    this.openLoading();
                    const response = await axios.post(`${API}/imprimir-receta`, datosEnviar);
                    if (response.data.status === 'success') {
                        this.closeLoading();
                        console.log('Receta médica generada:', response.data);
                        await this.callAudit(this.currentUser?.mainId,"IMPRESION","recetas",this.notaMedicaConsultas.id, `Impresión de receta médica`);

                        const pdfUrl = `${API}${response.data.pdfUrl}`;

                         // Verificar si es un dispositivo móvil
                         if (this.isMobileDevice()) {
                            // En móvil, abrir en una nueva pestaña
                            window.open(pdfUrl, '_blank');
                            this.notify('info', 'El PDF se abrirá en una nueva pestaña.');
                        } else {

                            const modal = document.createElement("div");
                            modal.style.position = "fixed";
                            modal.style.top = "0";
                            modal.style.left = "0";
                            modal.style.width = "100%";
                            modal.style.height = "100%";
                            modal.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
                            modal.style.display = "flex";
                            modal.style.justifyContent = "center";
                            modal.style.alignItems = "center";
                            modal.style.zIndex = "1051";

                            const iframe = document.createElement("iframe");
                            iframe.src = pdfUrl;
                            iframe.style.width = "80%";
                            iframe.style.height = "80%";
                            iframe.style.border = "2px solid white";
                            iframe.style.borderRadius = "10px";

                            const closeButton = document.createElement("span");
                            closeButton.textContent = "✖";
                            closeButton.style.position = "absolute";
                            closeButton.style.top = "20px";
                            closeButton.style.right = "20px";
                            closeButton.style.color = "white";
                            closeButton.style.fontSize = "24px";
                            closeButton.style.cursor = "pointer";
                            closeButton.addEventListener("click", () => {
                                document.body.removeChild(modal);
                            });

                            modal.appendChild(iframe);
                            modal.appendChild(closeButton);
                            document.body.appendChild(modal);
                        }
                    } else {
                        this.closeLoading();
                        this.notify('error', 'Error al generar la receta médica.');
                    }
                } catch (error) {
                    this.closeLoading();
                    this.notify('error', `Error al generar la receta: ${error.response?.data?.message || error.message}`);
                }
            },
            async copiarLinkReceta(consulta,recetaId) {
                var datosEnviar={};
                datosEnviar.displayName = this.currentUser?.displayName || 'No especificado';
                datosEnviar.personal_medico_id = this.currentUser?.mainId;
                datosEnviar.datosPaciente = this.paciente;
                datosEnviar.signos_vitales = this.notaMedicaConsultas.signos_vitales;
                datosEnviar.motivo = this.notaMedicaConsultas.motivo;
                datosEnviar.consulta_id = recetaId;
                datosEnviar.creado_en = consulta[0].receta_creado_en
                datosEnviar.tratamientos = consulta;
                
                console.log('Medicamento seleccionado:', datosEnviar);
          
                try {
                    this.openLoading();
                    const response = await axios.post(`${API}/imprimir-receta`, datosEnviar);
                    if (response.data.status === 'success') {
                        this.closeLoading();
                        console.log('Receta médica generada:', response.data);
                        await this.callAudit(this.currentUser?.mainId,"COPIAR ENLACE","recetas",this.notaMedicaConsultas.id, `Copia de enlace de receta médica`);

                        const pdfUrl = `${response.data.qrData}`;
                        navigator.clipboard.writeText(pdfUrl).then(() => {
                            this.notify('success', 'El enlace de la receta se ha copiado al portapapeles.');
                        }).catch(err => {
                            this.notify('error', 'No se pudo copiar el enlace al portapapeles.');
                        });
                    } else {
                        this.closeLoading();
                        this.notify('error', 'Error al generar la receta médica.');
                    }
                } catch (error) {
                    this.closeLoading();
                    this.notify('error', `Error al generar la receta: ${error.response?.data?.message || error.message}`);
                }
            },
            async agregarMedicamentos() {
                // if (!this.vEmpty(this.observaciones, 'Observaciones y/o recomendaciones')) return;


                // Validate prescribed medications
                const hasValidMedicamento = this.medicamentosRecetados.every(medicamento => {
                    if (!medicamento.medicamento || medicamento.medicamento.trim() === '') {
                        this.notify('error', 'El campo "Nombre medicamento" es obligatorio para todos los medicamentos.');
                        return false;
                    }
                    if (!medicamento.dosis || medicamento.dosis.trim() === '') {
                        this.notify('error', 'El campo "Dosis" es obligatorio para todos los medicamentos.');
                        return false;
                    }
                    if (!medicamento.frecuencia || medicamento.frecuencia.trim() === '') {
                        this.notify('error', 'El campo "Frecuencia" es obligatorio para todos los medicamentos.');
                        return false;
                    }
                    if (!medicamento.duracion || medicamento.duracion.trim() === '') {
                        this.notify('error', 'El campo "Duración" es obligatorio para todos los medicamentos.');
                        return false;
                    }
                    return true;
                });

                console.log('Medicamentos recetados:', this.medicamentosRecetados);
                if (this.medicamentosRecetados.length > 0 && !hasValidMedicamento) {
                    return;
                }

                try {
                    const consultaData = {
                        tratamientos: this.medicamentosRecetados,
                        observaciones_generales: this.observaciones,  
                        consulta_id: this.notaMedicaConsultas.id
                    };

                    console.log('Consulta data:', consultaData);

                    const response = await axios.post(`${API}/recetar_medicamentos`, consultaData);

                    if (response.data.status === 'success') {
                        this.notify('success', 'Medicamentos agregados exitosamente');

                        await this.callAudit(this.currentUser?.mainId,"CREAR","recetas",this.notaMedicaConsultas.id, `Se crea receta médica o estudios solicitados`);


                        this.resetForm();
                        this.$emit('terminaMedicamentos');
                        this.fetchRecetas(); 
                        this.fetchSolicitudesEstudios();
                        this.medicamentosRecetados = [];
                        this.observaciones = '';
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            },
            handleMedicamentoSelected(medicamento) {
                // Add the selected medication to the list of prescribed medications
                this.medicamentosRecetados.push({
                    medicamento: medicamento.nombre_medicamento || '',
                    dosis: medicamento.presentacion || '',
                    frecuencia: medicamento.dosis_usual || '',
                    duracion: '',
                    observaciones: medicamento.nombre_busqueda || ''
                });
            },
            agregarMedicamentoManual() {
                // Add a new empty medication object for manual entry
                this.medicamentosRecetados.push({
                    medicamento: '',
                    dosis: '',
                    frecuencia: '',
                    duracion: '',
                    observaciones: ''
                });
            },
            eliminarMedicamento(index) {
                // Remove a medication from the list
                this.medicamentosRecetados.splice(index, 1);
            },
            resetForm() {
                this.medicamentosRecetados = [];
            },
            // Added formatDate method
            formatDate(date) {
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                return new Date(date).toLocaleDateString('es-ES', options);
            },
            calculateAge(dateOfBirth) {
                if (!dateOfBirth) return 'No calculado';
                const birthDate = new Date(dateOfBirth);
                const today = new Date();
                let age = today.getFullYear() - birthDate.getFullYear();
                const monthDiff = today.getMonth() - birthDate.getMonth();
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                return `${age} años`;
            },
            async fetchRecetas() {
                try {
                    const response = await axios.get(`${API}/obtener_recetas`, {
                        params: { consulta_id: this.notaMedicaConsultas.id }
                    });
                    if (response.data.status === 'success') {
                        this.recetas = response.data.data;
                    } else {
                        this.notify('error', 'Error al obtener las recetas.');
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            },
            async fetchSolicitudesEstudios() {
                try {
                    const response = await axios.get(`${API}/obtener_solicitudes_estudios`, {
                        params: { consulta_id: this.notaMedicaConsultas.id }
                    });
                    if (response.data.status === 'success') {
                        this.solicitudesEstudios = response.data.data;
                    } else {
                        this.notify('error', 'Error al obtener las solicitudes de estudios.');
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            },
        },
        mounted() {
            this.fetchRecetas(); // Fetch recetas when the component is mounted
            this.fetchSolicitudesEstudios(); // Fetch solicitudes de estudios when the component is mounted
            setTimeout(() => {
                this.userStats = this.getUserStatus();
            }, 500);
        }
    };
</script>

<style>
    /* Add any necessary styles here */
</style>